<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-row>
      <v-col cols="12">
        <v-alert v-if="error_alert" text prominent type="error" icon="mdi-cloud-alert">{{
            error_alert
          }}</v-alert>
        <v-alert
            v-if="success_alert"
            text
            prominent
            type="success"
            icon="mdi-cloud-alert"
        >{{ success_alert }}</v-alert
        >
      </v-col>
      <v-col cols="12">
        <v-card-title>
          Corporate Client Setup
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>

          <template>
            <v-text-field
                v-model="search"
                prepend-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                outlined
                dense
            ></v-text-field>
          </template>
          <template>
            <v-row align="center" justify="space-around">
              <v-btn depressed color="primary" append-icon="mdi-printer" @click="printList"
              >Print
              </v-btn>
            </v-row>
          </template>
          <v-btn color="primary" @click="add_item()"
          ><v-icon>mdi-plus</v-icon></v-btn
          >
        </v-card-title>
        <div id="print">
          <v-card>
            <v-data-table
                :headers="headers"
                :items="PatientSourceDatas"
                class="elevation-1"
                :search="search"
                dense
                mobile-breakpoint="0"
                :loading="loadingstatus"
                loading-text="Loading... Please wait"
            >
              <template v-slot:item.ps_status="{ item }">
                <v-chip v-if="item.ps_status === 'Active'" dark color="green" label outlined small
                >Active
                </v-chip>
                <v-chip v-else dark color="orange" label outlined small
                >{{ item.ps_status || 'Close' }}
                </v-chip>
              </template>
              <template v-slot:item.parent_name="{ item }">
                {{ item.parent ? item.parent.ps_name : '' }}
              </template>
              <template v-slot:item.ps_create_date="{ item }">
                {{ item.ps_create_date }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-tooltip top >
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                        @click="edit_item(item)"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        class="ma-2"
                        color="orange"
                        label
                        outlined
                        small
                    ><v-icon> mdi-pencil </v-icon>
                    </v-chip>
                  </template>
                  <span>Edit</span>
                </v-tooltip>
              </template>
              <template v-slot:no-data>
                <v-btn color="primary" @click="get_corporatesetup()">Reset</v-btn>
              </template>
            </v-data-table>
          </v-card>
        </div>
      </v-col>
    </v-row>


    <template>
      <div class="text-center">
        <v-dialog v-model="method_item_dialog" width="500">
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              {{ formData.id ? 'Edit Corporate Client' : 'Add Corporate Client' }}
            </v-card-title>
            <template>
              <v-form>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                          v-model="formData.ps_name"
                          outlined
                          dense
                          label="Name"
                          required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-select
                          v-model="formData.ps_parent_id"
                          :items="PatientSourceParent"
                          item-value="id"
                          item-text="ps_name"
                          label="Organization"
                          outlined
                          dense
                      ></v-select>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                          v-model="formData.ps_con_discount"
                          outlined
                          dense
                          label="Consultation Discount"
                          required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                          v-model="formData.ps_invs_discount"
                          outlined
                          dense
                          label="Investigation Discount"
                          required
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12">
                      <v-text-field
                          v-model="formData.ps_op_discount"
                          outlined
                          dense
                          label="Operation Discount"
                          required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" >
                      <v-select
                          v-model="formData.ps_status"
                          :items="ps_status"
                          label="Item Status"
                          outlined
                          dense
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </template>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="method_item_dialog = false"> Cancel </v-btn>
              <v-btn text color="warning" @click="resetForm()"> Reset </v-btn>
              <v-btn color="primary" text :loading="submitting" @click="CorporateClintSubmit()"> Submit </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>

  </div>
</template>

<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../js/setup";
export default {
  data() {
    return {
      search: "",
      auto_search: "",
      dialog: false,
      method_item_dialog: false,
      error_alert: null,
      success_alert: null,
      loadingstatus: true,
      submitting: false,
      PatientSourceDatas: [],
      PatientSourceParent:[],
      category: [
        { key: "Investigations", value: "Investigations" },
        { key: "Investigation Other", value: "Investigation Other" },
        { key: "OPD", value: "OPD" },
        { key: "Pathology", value: "Pathology" },
      ],
      type: [
        { key: "Ocular", value: "Ocular" },
        { key: "Systemic", value: "Systemic" },
        { key: "Biochemical", value: "Biochemical" },
        { key: "Immunology", value: "Immunology" },
        { key: "Clinical Pathology", value: "Clinical Pathology" },
        { key: "Microbiology", value: "Microbiology" },
      ],
      ps_status: ['Active', 'Close'],
      headers: [
        { text: "Name", value: "ps_name" },
        { text: "Org/Project", value: "parent_name" },
        { text: "Consultation Discount", value: "ps_con_discount" },
        { text: "Investigation Discount", value: "ps_invs_discount" },
        { text: "Operation Discount", value: "ps_op_discount" },
        { text: "Status", value: "ps_status" },
        { text: "Create Date", value: "ps_create_date" },
        { text: "Action", value: "actions", sortable: false },
      ],
      desserts: [],
      autoheaders: [
        {
          text: "ID",
          align: "start",
          sortable: false,
          value: "id",
        },

        { text: "Action", value: "actions", sortable: false },
      ],
      formData: {
        id: null,
        ps_parent_id: null,
        ps_name: null,
        ps_con_discount: null,
        ps_invs_discount: null,
        ps_op_discount: null,
        ps_inv_doctor: null,
        ps_status: null,
      },
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Administrative",
          disabled: true,
        },
        {
          text: "Corporate Client Setup",
          disabled: true,
        },
      ],

    };
  },

  created() {
    let storedGroups = localStorage.getItem("userGroups") || "";
    let userGroups = storedGroups
        .split(",")
        .map(g => Number(g.trim()))
        .filter(g => !isNaN(g));

    let permittedGroups = [1, 8]; // Admin=1, Manager=8
    let hasAccess = userGroups.some(group => permittedGroups.includes(group));

    if (hasAccess) {
      console.log("Access Granted",hasAccess);
    } else {
      this.loadingstatus = false;
      this.error_alert = "Invalid Request";
      return false;
    }
    this.get_corporatesetup();
  },
  methods: {
    get_corporatesetup() {
      atshq
          .get("administrative/corporate-clint-setup")
          .then((response) => {
            this.PatientSourceDatas = response.data.PatientSource;
            this.PatientSourceParent = response.data.PatientSourceParent;
            this.loadingstatus = false;
          })
          .catch((e) => {
            this.error_alert = (e.response && e.response.data && e.response.data.message)
                || e.message
                || 'Failed to load corporate client data';
            this.loadingstatus = false;
          });
    },

    edit_item(item) {
      this.method_item_dialog = true;
      this.formData = {
        id: item.id,
        ps_parent_id: item.ps_parent_id,
        ps_name: item.ps_name,
        ps_con_discount: item.ps_con_discount,
        ps_invs_discount: item.ps_invs_discount,
        ps_op_discount: item.ps_op_discount,
        ps_inv_doctor: item.ps_inv_doctor,
        ps_status: item.ps_status,
      };
    },
    add_item() {
      this.formData = {
        id: null,
        ps_parent_id: null,
        ps_name: null,
        ps_con_discount: null,
        ps_invs_discount: null,
        ps_op_discount: null,
        ps_inv_doctor: null,
        ps_status: 'Active',
      };
      this.method_item_dialog = true;
    },

    resetForm() {
      if (this.formData.id) {
        const current = this.PatientSourceDatas.find((item) => item.id === this.formData.id);
        if (current) {
          this.edit_item(current);
          return;
        }
      }
      this.add_item();
    },
    buildSubmitPayload() {
      return {
        ps_parent_id: this.formData.ps_parent_id ? this.formData.ps_parent_id : 0,
        ps_name: (this.formData.ps_name || '').trim(),
        ps_con_discount: this.formData.ps_con_discount || 0,
        ps_invs_discount: this.formData.ps_invs_discount || 0,
        ps_op_discount: this.formData.ps_op_discount || 0,
        ps_status: this.formData.ps_status || 'Active',
      };
    },
    getErrorMessage(error) {
      if (error && error.response && error.response.data && error.response.data.message) {
        return error.response.data.message;
      }
      return (error && error.message) ? error.message : 'Request failed';
    },
    CorporateClintSubmit() {
      if (!confirm('Are you sure?')) {
        return;
      }

      if (!this.formData.ps_name || !String(this.formData.ps_name).trim()) {
        this.$noty.error('Name is required');
        return;
      }

      const userId = localStorage.getItem('userId');
      if (!userId) {
        this.$noty.error('Please login again, then try next process...');
        return;
      }

      const payload = {
        formdata: this.buildSubmitPayload(),
        user_id: userId,
      };

      this.submitting = true;

      if (this.formData.id) {
        atshq
            .put('administrative/corporate-clint-setup/' + this.formData.id, payload)
            .then((res) => {
              this.$noty.success(res.data.message);
              this.get_corporatesetup();
              this.method_item_dialog = false;
            })
            .catch((e) => {
              this.$noty.error(this.getErrorMessage(e));
            })
            .finally(() => {
              this.submitting = false;
            });
      } else {
        atshq
            .post('administrative/corporate-clint-setup', payload)
            .then((res) => {
              this.$noty.success(res.data.message);
              this.get_corporatesetup();
              this.method_item_dialog = false;
            })
            .catch((e) => {
              this.$noty.error(this.getErrorMessage(e));
            })
            .finally(() => {
              this.submitting = false;
            });
      }
    },
    printList() {
      var disp_setting = "toolbar=yes,location=no,";
      disp_setting += "directories=yes,menubar=yes,";
      disp_setting += "scrollbars=yes,width=650, height=600, left=100, top=25";
      var content_vlue = document.getElementById("print").innerHTML;
      var docprint = window.open("", "", disp_setting);
      docprint.document.open();
      docprint.document.write('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"');
      docprint.document.write('"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">');
      docprint.document.write(
          '<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">'
      );
      docprint.document.write('<style type="text/css">body{ margin:0px;');
      docprint.document.write("font-family:verdana,Arial;color:#000;");

      docprint.document.write(
          "font-family:Verdana, Geneva, sans-serif; font-size:10px;}"
      );
      docprint.document.write(
          "table td, table th {border: 1px solid #ddd;padding: 0px; font-size:9px;}"
      );
      docprint.document.write(
          "table th, table th {padding-top: 12px;padding-bottom: 12px;text-align: left;background-color: #4CAF50;color: white;}"
      );
      docprint.document.write("table {width: 100%;}");

      docprint.document.write("a{color:#000;text-decoration:none;} </style>");
      docprint.document.write('</head><body onLoad="self.print()"><center>');
      docprint.document.write("<h3> Corporate Client Setup  || " + this.date + "</h3>");
      docprint.document.write(content_vlue);
      docprint.document.write("</center></body></html>");
      docprint.document.close();
      docprint.focus();
    },
  },
};
</script>
